import { render, staticRenderFns } from "./SectionListSupervision.vue?vue&type=template&id=66b9a3c7&scoped=true&"
import script from "./SectionListSupervision.vue?vue&type=script&lang=js&"
export * from "./SectionListSupervision.vue?vue&type=script&lang=js&"
import style0 from "./SectionListSupervision.vue?vue&type=style&index=0&id=66b9a3c7&prod&lang=sass&scoped=true&"
import style1 from "./SectionListSupervision.vue?vue&type=style&index=1&id=66b9a3c7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b9a3c7",
  null
  
)

export default component.exports